import React, { useState } from 'react';
import './CodeExample.css';

/**
 * CodeExample Component
 * Displays syntax-highlighted code blocks with copy functionality
 */
const CodeExample = ({ 
  code = '', 
  language = 'javascript',
  title = 'Example'
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="code-example">
      <div className="code-example-header">
        <span className="code-example-title">{title}</span>
        <button 
          className="code-example-copy"
          onClick={handleCopy}
          aria-label="Copy code"
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <pre className="code-example-content">
        <code className={`language-${language}`}>{code}</code>
      </pre>
    </div>
  );
};

export default CodeExample;
